import HeroCarousel from "./components/HeroCarousel";
import CategoryEntrances from "./components/CategoryEntrances";
import MovieGridSection from "./components/MovieGridSection";
import HotRankList from "./components/HotRankList";
import SiteIntro from "./components/SiteIntro";
import {
  getEditorPicks,
  getFeaturedMovies,
  getHotMovies,
  getLatestMovies,
} from "@/utils/movie";
import usePageMeta from "@/hooks/usePageMeta";

export default function Home() {
  const featured = getFeaturedMovies();
  const latest = getLatestMovies(8);
  const hot = getHotMovies(8);
  const picks = getEditorPicks(4);

  usePageMeta({
    title: "激情丛林在线观看高清完整版 - 热门影视剧免费在线观看",
    description:
      "激情丛林网站提供激情丛林电视剧及电影在线观看服务，涵盖多类型影视内容，支持在线播放，让用户方便快捷观看高清影视剧。",
    keywords: "激情丛林,激情丛林在线观看,激情丛林电视剧,激情丛林电影,影视在线观看,高清影视,在线播放",
  });

  return (
    <>
      <HeroCarousel movies={featured} />
      <CategoryEntrances />
      <MovieGridSection
        title="最新更新"
        subtitle="刚刚上线的“激情丛林”系列与同类型影视内容"
        movies={latest}
      />
      <HotRankList movies={hot} />
      <MovieGridSection
        title="编辑推荐"
        subtitle="高评分口碑佳作，值得一看的影视精选"
        movies={picks}
        moreLink="/category/hot"
      />
      <SiteIntro />
    </>
  );
}